import React from 'react';
import PropTypes from 'prop-types';

const Share = ({ color = '#647A85', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M21.954 17.656v1.72A2.626 2.626 0 0 1 19.33 22H4.67a2.626 2.626 0 0 1-2.625-2.624v-1.72M12 2v15.475M5.665 8.335 12 2l6.335 6.335"
    />
  </svg>
);

Share.propTypes = {
  color: PropTypes.string
};

export default Share;
